import React from 'react';

import { Button } from '@components/Button/Button';
import { externalRoutes } from '@routes';
import { sales } from '@siteData';

import styles from './ErrorMessage.module.scss';

export type IErrorMessageType = 'email-used' | 'signup' | 'other';

export interface IProps {
  type?: IErrorMessageType;
  failedAttempts?: number;
}

const getText = (type: IErrorMessageType) => {
  switch (type) {
    case 'email-used':
      return {
        title: 'This email address is already in use.',
        text: (
          <span>
            Do you want to{' '}
            <Button className={styles.link} href={externalRoutes.client.login} external noIcon>
              log in
            </Button>
            ?
          </span>
        ),
      };
    case 'signup':
      return {
        title: 'Could not create an account.',
        text: 'Please, review the information and try again.',
      };
    default:
      return { title: 'Could not send the message.' };
  }
};

export const ErrorMessage: React.FC<IProps> = ({ type = 'other', failedAttempts = 0 }) => {
  const { title, text } = getText(type);

  return (
    <>
      <strong className={styles.title}>{title}</strong>
      {text ?? (
        <span>
          {failedAttempts <= 1 ? (
            'Please, try to send the form once again.'
          ) : (
            <>
              Please, try again later. Or let us know at{' '}
              <Button className={styles.link} href={`mailto:${sales.email}`}>
                {sales.email}
              </Button>
              .
            </>
          )}
        </span>
      )}
    </>
  );
};
